export default {
  AUTH_CALL_INIT_FIRST: "messages.authCallInitFirst",
  API_CALL_INIT_FIRST: "messages.apiCallInitFirst",
  INTERNAL_ERROR: "messages.internalError",
  BAD_REQUEST: "messages.badRequest",
  SERVER_ERROR: "messages.serverError",
  NO_RESPONSE: "messages.noResponse",
};
